import React, { useState, useEffect } from "react";
import FileUploadProductB from "./FileUploadProductB";
import { Header } from "./components/Header";
import "bootstrap/dist/css/bootstrap.min.css";
import ProductB from "./components/ProductB";
import { NavLink } from "react-router-dom";

const Productb = () => {
  const [items, setItems] = useState([]);
  const API_URL = "https://uat.atlas.docauto.riverchain.xyz/api";

  const fetchData = async () => {
    try {
      const [res1, res2] = await Promise.all([
        fetch(`${API_URL}/sitesb`),
        fetch(`${API_URL}/sitesb8_7`),
      ]);

      if (!res1.ok || !res2.ok) {
        throw new Error("API request error");
      }

      const data1 = await res1.json();
      const data2 = await res2.json();

      const itemsA = (data1?.isheet?.data?.item || []).map((item) => ({
        ...item,
        version: "",
      }));

      const itemsB = (data2?.isheet?.data?.item || []).map((item) => ({
        ...item,
        version: "8.7",
      }));

      const mergedItems = [...itemsA, ...itemsB];

      setItems(mergedItems);
    } catch (error) {
      console.error("Error fetching merged Product B data:", error);
    }
  };

  const handleDeleteProduct = async (item) => {
    try {
      const version = item.version;
      const id = item.itemid;

      if (!id) return;

      let deleteUrl = "";

      // Version-based API routing
      if (String(version).includes("8.7")) {
        deleteUrl = `${API_URL}/deleteProductb8_7/${id}`;
      } else {
        deleteUrl = `${API_URL}/deleteProductB/${id}`;
      }

      const res = await fetch(deleteUrl, { method: "DELETE" });

      if (!res.ok) {
        throw new Error(`Failed to delete: ${res.status}`);
      }

      // Refresh after delete
      fetchData();
    } catch (err) {
      console.error("Delete error", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="container-fluid">
      <Header />

      <div className="row" style={{ marginTop: "30px" }}>
        <div className="col-md-6">
          <NavLink
            to="/producta"
            className={({ isActive }) =>
              `btn btn-lg ${isActive ? "btn-dark" : "btn-outline-secondary"}`
            }
          >
            Product A
          </NavLink>

          <NavLink
            to="/productb"
            className={({ isActive }) =>
              `btn btn-lg ${
                isActive ? "btn-dark" : "btn-outline-secondary"
              } ms-2`
            }
          >
            Product B
          </NavLink>

          {/* <NavLink
            to="/productc"
            className={({ isActive }) =>
              `btn btn-lg ${
                isActive ? "btn-dark" : "btn-outline-secondary"
              } ms-2`
            }
          >
            Product C
          </NavLink> */}
        </div>
      </div>

      <div className="row" style={{ background: "#fefefe" }}>
        <div className="col-md-4">
          <FileUploadProductB onUploadSuccess={fetchData} />
        </div>

        <div className="col-md-8">
          <ProductB
            items={items}
            handleDeleteProduct={handleDeleteProduct}
            onUploadSuccess={fetchData}
          />
        </div>
      </div>
    </div>
  );
};

export default Productb;
